import React, { lazy } from 'react';
import { StarIcon } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function TestimoniosSection() {
  const testimonios = [{
    name: 'Carlos M.',
    location: 'Manhattan, New York',
    quote: 'Lo empecé usando por curiosidad, pero lo que más noté fue calma. Antes tomaba decisiones desde la ansiedad. Ahora hago la práctica diaria y siento más claridad para tomar decisiones.',
    rating: 5,
    image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/reza-biazar-eSjmZW97cH8-unsplash_1.jpg?v=1778469885'
  }, {
    name: 'Laura V.',
    location: 'Union City, New Jersey',
    quote: 'Los audios me ayudaron muchísimo a bajar el ruido mental. No lo veo como magia, lo veo como un espacio diario para ordenar mi energía, mi enfoque y mi relación con la abundancia.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop'
  }, {
    name: 'Alejandro R.',
    location: 'Miami, USA',
    quote: 'Era escéptico, pero el sistema me ayudó a crear una rutina. Empecé a visualizar, escribir y actuar con más intención. Me siento más centrado y con más dirección.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop'
  }, {
    name: 'Sofía H.',
    location: 'Houston, Texas',
    quote: 'Lo que más me sorprendió fue lo rápido que empecé a sentirme más tranquila. Antes estaba todo el día pensando en mis problemas con estrés. Ahora tengo momentos de pausa y eso me ha ayudado a ver todo con más claridad.',
    rating: 5,
    image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/callum-blacoe-Id6U55AZMpg-unsplash_1_1_1.jpg?v=1778470131'
  }, {
    name: 'Javier L.',
    location: 'Los Ángeles, California',
    quote: 'No es algo complicado. Son prácticas simples, pero cuando las haces todos los días empiezas a notar cambios en cómo piensas y reaccionas. Me siento más enfocado y con menos ruido mental.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&fit=crop'
  }, {
    name: 'Camila R.',
    location: 'Miami, Florida',
    quote: 'Me ayudó a crear un espacio para mí. Entre el trabajo y las preocupaciones no tenía tiempo para parar. Ahora con los audios siento más equilibrio y una forma diferente de relacionarme con lo que quiero lograr.',
    rating: 5,
    image: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/jake-nackos-IF9TK5Uy-KI-unsplash_1.jpg?v=1778469753'
  }];
  const [headerRef, headerInView] = useInView();
  const [cardsRef, cardsInView] = useInView();
  return <section id="resultados" className="py-10 sm:py-24 bg-dark relative border-t border-white/5 overflow-hidden scroll-mt-[56px] sm:scroll-mt-[70px]" data-id="element-622">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-[5%]" data-id="element-623">
        <div ref={headerRef} className={`text-center mb-10 sm:mb-14 will-animate animate-fadeIn ${headerInView ? 'is-visible' : ''}`} data-id="element-624">
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-black mb-6" data-id="element-625">
            Personas que ya{' '}
            <span className="text-gold" data-id="element-626">vivieron la experiencia</span>
          </h2>

          <p className="text-base sm:text-lg opacity-80 max-w-2xl mx-auto text-gold/80 font-medium" data-id="element-627">
            Conversaciones de personas que empezaron a aplicar Código 888
          </p>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6" data-id="element-628">
          {['https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_27_may_2026_02_33_54_p.m..png?v=1779908438', 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_27_may_2026_02_55_28_p.m..png?v=1779908438', 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_27_may_2026_02_35_14_p.m..png?v=1779908439', 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_27_may_2026_02_49_39_p.m..png?v=1779908439'].map((image, index) => <div key={index} className={`will-animate animate-fadeIn delay-${(index % 4 + 1) * 100} ${cardsInView ? 'is-visible' : ''} group`} data-id="element-629">
              <div className="relative rounded-2xl overflow-hidden bg-[#0c0c0e] border border-gold/20 shadow-[0_15px_45px_rgba(0,0,0,0.45)] hover:-translate-y-2 hover:shadow-[0_20px_55px_rgba(212,175,55,0.16)] hover:border-gold/40 transition-all duration-300" data-id="element-630">
                <img src={image} alt={`Chat de testimonio Código 888 ${index + 1}`} className="w-full h-auto block object-cover" loading="lazy" data-id="element-631" />

                <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-black/25 via-transparent to-white/5 opacity-70" data-id="element-632" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}